import type { PositionLayout, PositionType } from './types';

export const ICONS_BASE_URL = 'https://static.elfsight.com/icons';

export const positions: Record<PositionType, PositionLayout> = {
  'floating-left': {
    position: 'floating',
    align: 'left'
  },
  'floating-right': {
    position: 'floating',
    align: 'right'
  },
  'embed-left': {
    position: 'embed',
    align: 'left'
  }
};
